module.exports = __webpack_public_path__ + "static/media/address-gold.14897200.gif";